<template>
  <div>
    <table-list
      ref="table"
      idKey="id"
      :listConfig="listConfig"
      :searchConfig="searchConfig"
      :apis="apis"
      :createFrom="fromConfig"
      :btn-config="btnConfig"
      @handleBtn="handleBtn"
      :btnConfig="btnConfig | filterBtnsRole($route)">
      <div slot="bills" slot-scope="data">
        <el-image
          v-for="item in getBills(data.row.bills)"
          :key="item"
          style="width: 50px; height: 50px;margin-right: 5px;"
          :src="item"
          :preview-src-list="getBills(data.row.bills)">
        </el-image>
      </div>
    </table-list>
    <from-list :fromConfig="rejectConfig" ref="reject" @confirm="confirm"></from-list>
  </div>
</template>

<script>
import config from './config/incidental.config'
import { openMessageBox } from '@/utils'
import { audit } from "@/api/incidental.finance";

export default {
  data() {
    return {
      roadList: [],
      submitConfig: [],
      rejectConfig: [],
      ...config()
    }
  },
  computed: {
    getBills() {
      return function(bills) {
        return bills.split(',')
      }
    }
  },
  methods: {
    handleBtn(key, list) {
      if (key === 'reject') {
        if (list.length !== 1) this.$error('请选择一项操作');
        this.rejectConfig = this.createReject();
        this.$refs[key].open(null, { ids: list.map(x => x.id) })
      } else {
        if (list.length < 1) this.$error('请选择一项操作');
        openMessageBox({ content: '是否通过此条信息？' }, boolean => {
          if (boolean) {
            this.apis.tgApi({ type: 1, ids: list.map(x => x.id), remark: "" }).then(res => {
              this.$refs.table.getList();
            })
          }
        })
      }

    },
    confirm(val) {
      this.apis.rejectApi({ type: 2, ids: val.ids, remark: this.rejectConfig[1].value }).then(res => {
        this.$refs.reject.close();
        this.$refs.table.getList();
      })
    }
  }
}
</script>

<style lang="less" scoped>

</style>
